// @ts-nocheck
import { Plugin } from 'D:/fe-dx-agent/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','antd','getInitialState','initialStateConfig','layout','layoutActionRef','request',],
});

export { plugin };
